import React from 'react';

import styled from 'styled-components';

const SVG = styled.svg`
  position: absolute; /* take out of document flow */
`;

const TicketPath = ({ id }: { id: string }) => {
  return (
    <SVG
      width="0"
      height="0"
      viewBox="0 0 664 288" // original dimensions: 664px * 288px
    >
      <title>Ticket Path</title>
      <defs>
        <clipPath
          id={id}
          clipPathUnits="objectBoundingBox"
          // path must be scaled to 0-1 so we apply this transform: scale(1/664, 1/288)
          transform="scale(0.001506024096, 0.003472222222)"
        >
          <path d="M0 111.189V0h663.75v110.255c-12.246.294-22.125 14.966-22.125 32.995 0 18.029 9.879 32.701 22.125 32.995V287.25H0V175.311c9.841-3.522 17.155-16.549 17.155-32.061S9.841 114.711 0 111.189z" />
        </clipPath>
      </defs>
    </SVG>
  );
};

export default TicketPath;
